import React from 'react';
import styled from "styled-components";
import { BodyVerySmall } from '@shared/ui/atoms/fonts/Body';
import Colours from '@shared/ui/atoms/Colours';
import { useTranslation } from "react-i18next";

export function CustomLeaveInfo(props: Props) {
  const {customLeave} = props;
  const {t} = useTranslation();
  return (
    <Container>
      <BodyVerySmall weight={700} style={{marginBottom: 8}}>{t('Other leave used this year')}</BodyVerySmall>
      {customLeave.map((leave, key) => (
        <Row key={key}>
          <BodyVerySmall colour={Colours.black}>{leave.label}</BodyVerySmall>
          <BodyVerySmall colour={Colours.darkGrey} style={{textTransform: 'lowercase'}}>{t('allowance.days', {days: leave.count})}</BodyVerySmall>
        </Row>
      ))}
    </Container>
  )
}

interface Props {
  customLeave: any[];
}

const Container = styled.div`

`

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${Colours.lightGrey};
  padding-bottom: 8px;
  margin-bottom: 8px;
  &:last-child {
    border: none !important;
  }
`
